import { registerQuery, useQuery } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import authHttpClient from 'hub-http/clients/apiClient';
import { getAccessControlsRpc } from 'automation-ui-canvas/__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService';
import { jsx as _jsx } from "react/jsx-runtime";
const chirpClient = createRpcClientV2({
  hubHttpClient: authHttpClient
});
export const GET_AI_SETTINGS_ACCESS = registerQuery({
  fieldName: 'aiSettingsAccess',
  fetcher() {
    return chirpClient.call(getAccessControlsRpc, {});
  }
});
export const wireAiAccessSettings = WrappedComponent => props => {
  const {
    data,
    loading
  } = useQuery(GET_AI_SETTINGS_ACCESS);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    aiAccessSettings: data === null || data === void 0 ? void 0 : data.aiSettingsAccess,
    aiAccessSettingsLoading: loading
  }));
};